module.exports = __webpack_public_path__ + "static/media/coming.99200a9a.jpg";